import "../../chunk-7QVYU63E.js";
const DRUID_AGGREGATE_NAME = "metric";
var DataSourceType = /* @__PURE__ */ function(DataSourceType2) {
  DataSourceType2["ApiLogs"] = "apiLogs";
  DataSourceType2["ApiDW"] = "apiDW";
  DataSourceType2["ApiSubscriptionLogs"] = "apiSubscriptionLogs";
  DataSourceType2["ApiSubscriptionDW"] = "apiSubscriptionDW";
  return DataSourceType2;
}({});
var Period = /* @__PURE__ */ function(Period2) {
  Period2["Minute_5"] = "Minute_5";
  Period2["Hour_1"] = "Hour_1";
  Period2["Hour_24"] = "Hour_24";
  Period2["Day_7"] = "Day_7";
  Period2["Day_30"] = "Day_30";
  return Period2;
}({});
export {
  DRUID_AGGREGATE_NAME,
  DataSourceType,
  Period
};
//# sourceMappingURL=druid.js.map